import { render, staticRenderFns } from "./VendorUsersTable.vue?vue&type=template&id=9645ffa4&scoped=true&"
import script from "./VendorUsersTable.vue?vue&type=script&lang=js&"
export * from "./VendorUsersTable.vue?vue&type=script&lang=js&"
import style0 from "./VendorUsersTable.vue?vue&type=style&index=0&id=9645ffa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9645ffa4",
  null
  
)

export default component.exports